import { useEffect, useMemo, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import PageLayout from "components/layout/page-layout";
import Table, { tableHeader } from "components/table";
import { oneLine, tagsList } from "components/table/table-parts";
import { useSharedState } from "state";
import ActionButton from "components/table/action-btn";
import { IconEye, IconLock, IconLockOpen, IconPencil } from "@tabler/icons-react";
import { updateLevel } from "api/level";
import { LevelDefault, LevelType } from "types/dict";
import WarningModal from "components/modal/warning";

export default function Levels() {
  const { levels, getLevelsData, levelRoots, getLevelRootsData, notify } = useSharedState();

  const navigate = useNavigate();

  const [levelToChange, setLevelToChange] = useState<LevelType>(LevelDefault);
  const [isFormLoading, setFormLoading] = useState<boolean>(false);

  const changeWarning = "Вы действительно хотите изменить статус уровня?";

  const sublevels = useMemo(() => {
    return levels
      .map((sub_lvl) => sub_lvl.level_number)
      .filter((value, index, array) => array.indexOf(value) === index && value !== 0);
  }, [levels]);

  const sublevelsListByParent = useMemo(() => {
    return (parent_lvl: LevelType, sub_lvl_number: number) =>
      levels.filter(
        (lvl) => lvl.level_number === sub_lvl_number && lvl.parent_budget_type_id === parent_lvl.budget_type_id
      );
  }, [levels]);

  useEffect(() => {
    getLevelsData();
    getLevelRootsData();
    setTimeout(() => {
      const tbody = document.querySelector("tbody");
      if (tbody) {
        tbody.classList.add("accordion");
        tbody.id = "accordion-level";
      }
    }, 0);
  }, []);

  const onLevelChange = async () => {
    setFormLoading(true);

    try {
      await updateLevel(levelToChange, !!!levelToChange.status);
      notify("Статус уровня изменён", "success");

      await getLevelsData();
    } catch (error: any) {
      let err = JSON.stringify(error?.response?.data?.detail);
      notify(err, "danger", "Ошибка при изменении статуса уровня");
    } finally {
      setFormLoading(false);
      setLevelToChange(LevelDefault);
    }
  };

  // const levelsTableHeaders: tableHeader[] = [
  //   { header_text: "Название уровня", narrow: false, wrap: false },
  //   ...levels
  //     .map((sub_lvl) => sub_lvl.level_number)
  //     .filter((value, index, array) => array.indexOf(value) === index && value !== 0)
  //     .map((sub_lvl) => ({ header_text: `Уровень ${sub_lvl}`, narrow: false, wrap: false })),
  //   { header_text: "Действия", narrow: false, wrap: false },
  // ];

  const levelRootsTableHeaders: tableHeader[] = [
    { header_text: "Название уровня", narrow: false, wrap: false },
    { header_text: "Действия", narrow: true, wrap: false },
  ];

  // const levelsList = (
  //   <>
  //     {levels
  //       .filter((lvl) => lvl.parent_budget_type_id === null)
  //       .map((level, lvl_index) => (
  //         <tr key={lvl_index}>
  //           <td className="align-content-start">{oneLine(level.budget_type || "-")}</td>
  //           {sublevels.map((sub_lvl, sub_lvl_index) => (
  //             <td key={sub_lvl_index} className="align-content-start">
  //               {tagsList(
  //                 [
  //                   ...sublevelsListByParent(level, sub_lvl!)
  //                     .slice(0, 3)
  //                     .map((tag) => tag.budget_type || ""),
  //                   sublevelsListByParent(level, sub_lvl!).slice(4).length
  //                     ? `... ещё ${sublevelsListByParent(level, sub_lvl!).slice(4).length.toString()}`
  //                     : "",
  //                 ].filter((tag) => tag),
  //                 [
  //                   ...sublevelsListByParent(level, sub_lvl!)
  //                     .slice(0, 3)
  //                     .map((tag) => (!!!tag.status ? "danger" : "")),
  //                   "primary",
  //                 ]
  //               )}
  //             </td>
  //           ))}
  //           <td className="align-content-start">
  //             <div className="btn-list flex-nowrap">
  //               <ActionButton
  //                 icon={<IconPencil className="icon" />}
  //                 title="Изменить"
  //                 action={() => navigate(`${level.budget_type_id}`)}
  //                 color={"info"}
  //                 modal={false}
  //               />
  //               <ActionButton
  //                 icon={level.status ? <IconLock className="icon" /> : <IconLockOpen className="icon" />}
  //                 title={`${level.status ? "Деактивировать" : "Активировать"}`}
  //                 action={() => setLevelToChange(level)}
  //                 color={`${level.status ? "danger" : "success"}`}
  //                 modal={true}
  //                 modal_id="#modal-change-level"
  //               />
  //             </div>
  //           </td>
  //         </tr>
  //       ))}
  //   </>
  // );

  const levelRootsList = (
    <>
      {levelRoots.map((level, lvl_index) => (
        <tr key={lvl_index}>
          <td>{oneLine(level.budget_type || "-")}</td>
          <td>
            <div className="btn-list flex-nowrap">
              <ActionButton
                icon={<IconPencil className="icon" />}
                title="Изменить"
                action={() => navigate(`${level.budget_type_id}`)}
                color={"primary"}
                modal={false}
              />
              {/* <ActionButton
                icon={<IconPencil className="icon" />}
                title="Изменить"
                action={() => navigate(`${level.budget_type_id}`)}
                color={"info"}
                modal={false}
              /> */}
              <ActionButton
                icon={level.status ? <IconLock className="icon" /> : <IconLockOpen className="icon" />}
                title={`${level.status ? "Деактивировать" : "Активировать"}`}
                action={() => setLevelToChange(level)}
                color={`${level.status ? "danger" : "success"}`}
                modal={true}
                modal_id="#modal-change-level"
              />
            </div>
          </td>
        </tr>
      ))}
    </>
  );

  const levelsTable = Table(levelRootsTableHeaders, levelRootsList, false);

  return (
    <>
      <PageLayout
        children={levelsTable}
        header={"Уровни"}
        search={false}
        filters={false}
        sorters={false}
        buttonText={"Новый уровень"}
        buttonAction={() => navigate("create")}
      />
      <WarningModal
        modal_id="modal-change-level"
        warningDescription={changeWarning}
        cancel={() => setLevelToChange(LevelDefault)}
        confirm={onLevelChange}
      />
      <Outlet />
    </>
  );
}
